export function isTimeFormat(timeString) {
  const cleanedTimeString = timeString?.trim();
  const timeFormat = /^(0[1-9]|1[0-2]):[0-5][0-9] (AM|PM)$/i;
  const rez = timeFormat.test(cleanedTimeString);
  return rez;
}
